<!-- @format -->

<ng-container *transloco="let t">
  <sis-course-unit-info-modal-text-field class="tweet-text" [localizedStringValue]="courseUnit.tweetText" [language]="language">
  </sis-course-unit-info-modal-text-field>
  <div class="row basic-info">
    <div class="col-12 col-md-6">
      <sis-tiny-static-form-group [label]="t('STUDIES.COURSE_UNITS_BASICINFO.CREDIT_RANGE')">
        @if (courseUnit.credits) {
          <span class="value">
            {{ courseUnit.credits | creditRange: "TEXT" : false }}
          </span>
        } @else {
          <span class="sis-placeholder">
            <sis-icon icon="alert-fill-attention"></sis-icon>{{ t("SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.NO_INFORMATION_GIVEN") }}
          </span>
        }
      </sis-tiny-static-form-group>
      <sis-tiny-static-form-group [label]="t('STUDIES.COURSE_UNIT_INFO_MODAL.POSSIBLE_ATTAINMENT_LANGUAGES')">
        @if (courseUnit.possibleAttainmentLanguages?.length > 0) {
          <span class="value">
            @for (languageUrn of courseUnit.possibleAttainmentLanguages; track languageUrn; let isLast = $last) {
              {{ languageUrn | codeLocalizedName | async }}
              @if (!isLast) {
                <span>,</span>
              }
            }
          </span>
        } @else {
          <span class="sis-placeholder">
            <sis-icon icon="alert-fill-attention"></sis-icon>{{ t("SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.NO_INFORMATION_GIVEN") }}
          </span>
        }
      </sis-tiny-static-form-group>
      <sis-tiny-static-form-group [label]="t('STUDIES.COURSE_UNITS_BASICINFO.GRADE_SCALE')">
        @if (courseUnit.gradeScaleId) {
          <span class="value">
            {{ courseUnit.gradeScaleId | gradeScale | async | entityName | localizedString }}
          </span>
        } @else {
          <span class="sis-placeholder">
            <sis-icon icon="alert-fill-attention"></sis-icon>{{ t("SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.NO_INFORMATION_GIVEN") }}
          </span>
        }
      </sis-tiny-static-form-group>
    </div>
    <div class="col-12 col-md-6">
      <sis-tiny-static-form-group [label]="t('STUDIES.COURSE_UNIT_INFO_MODAL.COURSE_UNIT_TYPE')">
        @if (courseUnit.courseUnitType) {
          <span class="value">
            {{ courseUnit.courseUnitType | codeLocalizedName | async }}
          </span>
        } @else {
          <span class="sis-placeholder">
            <sis-icon icon="alert-fill-attention"></sis-icon>{{ t("SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.NO_INFORMATION_GIVEN") }}
          </span>
        }
      </sis-tiny-static-form-group>
      <sis-tiny-static-form-group [label]="t('STUDIES.COURSE_UNIT_INFO_MODAL.STUDY_LEVEL')">
        @if (courseUnit.studyLevel) {
          <span class="value">
            {{ courseUnit.studyLevel | codeLocalizedName | async }}
          </span>
        } @else {
          <span class="sis-placeholder">
            <sis-icon icon="alert-fill-attention"></sis-icon>{{ t("SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.NO_INFORMATION_GIVEN") }}
          </span>
        }
      </sis-tiny-static-form-group>
      <sis-tiny-static-form-group [label]="t('STUDIES.COURSE_UNIT_INFO_MODAL.CEFR_LEVEL')">
        @if (courseUnit.cefrLevel) {
          <span class="value">
            {{ courseUnit.cefrLevel | codeLocalizedName | async }}
          </span>
        } @else {
          <span class="sis-placeholder">
            <sis-icon icon="alert-fill-attention"></sis-icon>{{ t("SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.NO_INFORMATION_GIVEN") }}
          </span>
        }
      </sis-tiny-static-form-group>
    </div>
  </div>

  <sis-expandable [level]="3" [title]="t('STUDIES.COURSE_UNIT_INFO_MODAL.DESCRIPTION')" [closed]="false">
    <ng-template sisExpandableContent>
      <div class="row">
        <div class="col-12 col-md-6 form-group-mimic">
          <h4>{{ t("STUDIES.COURSE_UNIT_INFO_MODAL.OUTCOMES") }}</h4>
          <sis-course-unit-info-modal-text-field
            [localizedMarkupStringValue]="courseUnit.outcomes"
            [language]="language"></sis-course-unit-info-modal-text-field>
        </div>
        <div class="col-12 col-md-6 form-group-mimic">
          <h4>{{ t("STUDIES.COURSE_UNIT_INFO_MODAL.CONTENT") }}</h4>
          <sis-course-unit-info-modal-text-field
            [localizedMarkupStringValue]="courseUnit.content"
            [language]="language"></sis-course-unit-info-modal-text-field>
        </div>
        <div class="col-12 col-md-6 form-group-mimic">
          <h4>{{ t("STUDIES.COURSE_UNIT_INFO_MODAL.ADDITIONAL") }}</h4>
          <sis-course-unit-info-modal-text-field
            [localizedMarkupStringValue]="courseUnit.additional"
            [language]="language"></sis-course-unit-info-modal-text-field>
        </div>
      </div>
    </ng-template>
  </sis-expandable>

  <sis-expandable [level]="3" [title]="t('STUDIES.COURSE_UNIT_INFO_MODAL.OVERVIEW_PREREQUISITES')" [closed]="false">
    <ng-template sisExpandableContent>
      <div class="row">
        <div class="col-12 col-md-6 form-group-mimic">
          <h4>{{ t("STUDIES.COURSE_UNIT_INFO_MODAL.PREREQUISITES_DESCRIPTION") }}</h4>
          <sis-course-unit-info-modal-text-field
            [localizedMarkupStringValue]="courseUnit.prerequisites"
            [language]="language"></sis-course-unit-info-modal-text-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-5">
          <sis-basic-grouping-panel
            [hideGroupingPanel]="!courseUnit.compulsoryFormalPrerequisites || courseUnit.compulsoryFormalPrerequisites.length === 0"
            [heading]="'STUDIES.COURSE_UNIT_INFO_MODAL.OVERVIEW_COMPULSORY_FORMAL_PREREQUISITES'">
            <sis-prerequisites [prerequisites]="courseUnit.compulsoryFormalPrerequisites"></sis-prerequisites>
          </sis-basic-grouping-panel>
        </div>
        <div class="col-12 col-md-5 offset-md-1">
          <sis-basic-grouping-panel
            [hideGroupingPanel]="!courseUnit.recommendedFormalPrerequisites || courseUnit.recommendedFormalPrerequisites.length === 0"
            [heading]="'STUDIES.COURSE_UNIT_INFO_MODAL.OVERVIEW_RECOMMENDED_FORMAL_PREREQUISITES'">
            <sis-prerequisites [prerequisites]="courseUnit.recommendedFormalPrerequisites"></sis-prerequisites>
          </sis-basic-grouping-panel>
        </div>
      </div>
    </ng-template>
  </sis-expandable>

  <sis-expandable [level]="3" [title]="t('STUDIES.COURSE_UNITS_DESCRIPTION.LEARNING_MATERIAL')" [closed]="false">
    <ng-template sisExpandableContent>
      <div class="row">
        <div class="col-12 col-md-6 form-group-mimic">
          <h4>{{ t("STUDIES.COURSE_UNIT_INFO_MODAL.LEARNING_MATERIAL") }}</h4>
          <sis-course-unit-info-modal-text-field [localizedMarkupStringValue]="courseUnit.learningMaterial" [language]="language">
          </sis-course-unit-info-modal-text-field>
        </div>
        <div class="col-12 col-md-6 form-group-mimic">
          <h4>{{ t("STUDIES.COURSE_UNITS_DESCRIPTION.LITERATURE") }}</h4>
          @if (courseUnit.literature?.length > 0) {
            @for (item of courseUnit.literature; track item) {
              <sis-markup-string-view [content]="item | literature"></sis-markup-string-view>
            }
          } @else {
            <span class="sis-placeholder">
              <sis-icon icon="alert-fill-attention"></sis-icon>{{ t("SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.NO_INFORMATION_GIVEN") }}
            </span>
          }
        </div>
      </div>
    </ng-template>
  </sis-expandable>

  <sis-expandable [level]="3" [title]="t('STUDIES.COURSE_UNIT_INFO_MODAL.TITLE_CLASSIFICATION')" [closed]="false">
    <ng-template sisExpandableContent>
      <div class="row">
        <div class="col-12 col-md-6 form-group-mimic">
          <h4>{{ t("STUDIES.COURSE_UNIT_INFO_MODAL.STUDY_FIELDS") }}</h4>
          @if (courseUnit.studyFields?.length > 0) {
            @for (studyFieldUrn of courseUnit.studyFields; track studyFieldUrn) {
              <span>{{ studyFieldUrn | codeLocalizedName | async }}</span>
            }
          } @else {
            <span class="sis-placeholder">
              <sis-icon icon="alert-fill-attention"></sis-icon>{{ t("SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.NO_INFORMATION_GIVEN") }}
            </span>
          }
        </div>
        <div class="col-12 col-md-6 form-group-mimic">
          <div class="search-tags">
            <h4>{{ t("STUDIES.COURSE_UNIT_INFO_MODAL.SEARCH_TAGS") }}</h4>
            @if (courseUnit.searchTags?.length > 0) {
              @for (tag of courseUnit.searchTags; track tag; let isLast = $last) {
                <span
                  >{{ tag }}
                  @if (!isLast) {
                    <span>,&nbsp;</span>
                  }
                </span>
              }
            } @else {
              <span class="sis-placeholder">
                <sis-icon icon="alert-fill-attention"></sis-icon>{{ t("SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.NO_INFORMATION_GIVEN") }}
              </span>
            }
          </div>
        </div>
      </div>
    </ng-template>
  </sis-expandable>

  <sis-expandable [level]="3" [title]="t('STUDIES.COURSE_UNIT_INFO_MODAL.RESPONSIBILITY_TEACHERS_AND_CONTACT_INFO')" [closed]="false">
    <ng-template sisExpandableContent>
      <sis-module-responsibility-info
        [responsibilityInfos]="courseUnit.responsibilityInfos"
        [language]="language"></sis-module-responsibility-info>
      <sis-responsible-organisation-info [organisations]="courseUnit.organisations"></sis-responsible-organisation-info>
    </ng-template>
  </sis-expandable>
</ng-container>
